import { render } from "./AboutUsContent.vue?vue&type=template&id=44a336f6"
import script from "./AboutUsContent.vue?vue&type=script&lang=js"
export * from "./AboutUsContent.vue?vue&type=script&lang=js"

import "./AboutUsContent.vue?vue&type=style&index=0&id=44a336f6&lang=css"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__